import React from "react";

interface Props {
  activePlatform: string;
  showGoogleRatings: boolean;
  windowDays: number;
  negativeAspectList: Array<{ label: string; count: number; pct: number }>;
  renderPlatformBadge: () => React.ReactNode;
}

export function SocialDiagnosisSection({
  activePlatform,
  showGoogleRatings,
  windowDays,
  negativeAspectList,
  renderPlatformBadge,
}: Props) {
  const isMetaIg = activePlatform === "meta_ig" || activePlatform === "instagram";
  const isMetaFb = activePlatform === "meta_fb" || activePlatform === "facebook";
  const isGoogle = activePlatform === "gbp" || activePlatform === "google";

  const platformBadgeLabel = isMetaIg
    ? "Instagram"
    : isMetaFb
    ? "Facebook"
    : isGoogle
    ? "Google BP"
    : "Visión Global";

  return (
    <section id="section-social-diagnosis" className="social-editorial-section">
      <div className="social-section-tag">DIAGNÓSTICO</div>
      <h2 className="social-section-title">
        {!showGoogleRatings
          ? "Qué temas generan fricción en la comunidad"
          : "Qué molesta a quienes puntúan bajo"}
      </h2>
      <p className="social-section-subtitle">
        {!showGoogleRatings
          ? `Los temas de los comentarios negativos apuntan a dudas, fricciones o reclamos recurrentes en ${platformBadgeLabel}.`
          : "Los temas de las reseñas negativas apuntan a las causas raíz del servicio que hay que corregir."}
      </p>

      <div className="social-editorial-badges">
        {renderPlatformBadge()}
        <span className="social-role-badge">Operaciones</span>
        <span className="social-role-badge">Dirección</span>
      </div>

      <div className="social-trend-row">
        {/* Temas negativos */}
        <div className="social-trend-box" style={{ width: "100%" }}>
          <h4 style={{ margin: "0 0 4px 0", fontSize: "14px", fontWeight: 700, color: "var(--text, #f6f7fb)" }}>
            {isGoogle ? "Temas con más reseñas negativas" : "Temas con más comentarios negativos"}
          </h4>
          <p style={{ margin: "0 0 16px 0", fontSize: "11.5px", color: "var(--muted, #8e96a8)" }}>
            Frecuencia de menciones en los comentarios negativos de los últimos {windowDays} días.
          </p>

          <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            {negativeAspectList.length === 0 ? (
              <div style={{ padding: "16px 0", color: "var(--muted, #8e96a8)", fontSize: "12px" }}>
                No se registran comentarios negativos en el período seleccionado.
              </div>
            ) : (
              negativeAspectList.map((row) => (
                <div key={row.label} style={{ display: "flex", alignItems: "center", gap: "12px", fontSize: "12px" }}>
                  <span style={{ width: "160px", color: "var(--muted, #8e96a8)", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                    {row.label}
                  </span>
                  <div style={{ flex: 1, height: "14px", background: "rgba(255, 255, 255, 0.06)", borderRadius: "4px", overflow: "hidden" }}>
                    <div style={{ height: "100%", width: `${row.pct}%`, background: "var(--red, #ff5c5c)", borderRadius: "4px" }} />
                  </div>
                  <span style={{ width: "20px", textAlign: "right", fontWeight: 700, color: "var(--text, #f6f7fb)" }}>
                    {row.count}
                  </span>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
